/** Returned in API `{ success: false, error }` from integrations-server upload. */
export const WA_NOTIFICATION_SOUND_ERRORS = {
  TOO_LARGE: "too_large",
  INVALID_FORMAT: "invalid_format",
} as const;

export type WaNotificationSoundErrorCode = (typeof WA_NOTIFICATION_SOUND_ERRORS)[keyof typeof WA_NOTIFICATION_SOUND_ERRORS];

/** Desktop/extension `WA_NOTIFICATION_SOUND_PICK` outcomes (not API error codes). */
export const WA_NOTIFICATION_SOUND_PICK_ERRORS = {
  CANCELLED: "cancelled",
  UPLOAD_FAILED: "upload_failed",
  READ_FAILED: "read_failed",
} as const;

export type WaNotificationSoundPickErrorCode =
  | (typeof WA_NOTIFICATION_SOUND_PICK_ERRORS)[keyof typeof WA_NOTIFICATION_SOUND_PICK_ERRORS]
  | WaNotificationSoundErrorCode;
